import React, { lazy, Suspense } from 'react';
import { defineMessage } from 'react-intl';

// Lazy-loaded so the support-chat -> feature-gates -> global-selectors (store) closure it pulls is NOT
// statically bundled into the error-message service. That service is imported by the login page, which
// must not pull the Redux store. The fallback renders the link text as plain children until it loads.
const LinkToSuncoChat = lazy(() => import('./link-to-sunco-chat').then((m) => ({ default: m.LinkToSuncoChat })));

const messageValues = {
  link: (chunks) => (
    <Suspense fallback={chunks}>
      <LinkToSuncoChat>{chunks}</LinkToSuncoChat>
    </Suspense>
  ),
};

// TODO: At time of writing, FedEx (wallet) is the only provider that requires prior approval and will hit this error message
// The challenge was resolving the fulfillmentPlanId in a label batch error
// to a Carrier/Provider name in a non-hook function
// finding all of the potential callers and wiring down state
export const message = defineMessage({
  description: 'Error message saying the selected provider service is not available to use as it is pending approval',
  defaultMessage: 'Selected carrier services are pending approval. Need help? <link>Contact support</link>.',
  id: 'ht0xGZ',
});

export const walletProviderApprovalPendingMessageBuilder = () => {
  return {
    ...message,
    values: messageValues,
  };
};
